/**
 * SGKC023A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CtrCommonMstInfo {

    /**
     * サービス契約番号
     */
    srvCtrNo?: string;
    /**
     * プロダクトコード
     */
    prdCode?: string;
    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * 請求月度区分
     */
    claimMnttmDiv?: string;
    /**
     * 契約有効期間開始日付
     */
    ctrefctkiStrtdate?: string;
    /**
     * 契約有効期間終了日付
     */
    ctrEfctedDate?: string;
}

